<template>
  <b-tooltip custom-class="main-tooltip" :target="String(target)" :placement="placement" triggers="hover">
    <div v-if="isHtml" v-html="tooltipValue" />
    <template v-else>{{ tooltipValue }}</template>
  </b-tooltip>
</template>

<script>
export default {
  props: {
    tooltipValue: {
      type: String,
    },
    target: {
      type: [String, Number],
      require: true,
    },
    isHtml: {
      type: Boolean,
      require: false,
      default: false,
    },
    placement: {
      type: String,
      require: false,
      default: "topright",
    },
  },
};
</script>

<style>
.main-tooltip {
  opacity: 1 !important;
}

.main-tooltip .tooltip-inner {
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  color: var(--black-color);
  background-color: var(--white-color);
  padding: 12px;
  filter: drop-shadow(0px 3px 8px rgba(5, 6, 36, 0.15)) drop-shadow(0px 1px 4px rgba(5, 6, 36, 0.12));
}

.main-tooltip .arrow::before {
  border-top-color: var(--white-color);
  border-bottom-color: var(--white-color);
}
</style>
